import type { CardHooks } from "./registry";

/**
 * Pick Up Your Weapon — Maneuver utility.
 * Effect: both players' weapons are readied; both players draw 1 and gain 3
 * stamina.
 *
 * Implementation: hook-driven, no engine coupling.
 *   • Ready BOTH players' equipSlots (set tapped=false on every occupied
 *     slot regardless of current state).
 *   • Both players: +3 stamina, +1 card draw.
 *
 * Stamina is patched directly through selfPatch/opponentPatch (mergePatch
 * replaces the field). drawSelf/drawOpponent route through applyResults's
 * draw plumbing (which also fires the opponent-draws-card Action Chain
 * event from each side — the engine handles that bookkeeping).
 *
 * Card-form note: no new fields needed.
 */
export const pickUpYourWeapon: CardHooks = {
  onUtilityPlay: (ctx) => {
    const selfSlots = (ctx.self.equipSlots ?? []).map((s) =>
      s?.cardId ? { ...s, tapped: false } : s,
    );
    const oppSlots = (ctx.opponent.equipSlots ?? []).map((s) =>
      s?.cardId ? { ...s, tapped: false } : s,
    );
    return {
      selfPatch: {
        equipSlots: selfSlots,
        stamina: ctx.self.stamina + 3,
      },
      opponentPatch: {
        equipSlots: oppSlots,
        stamina: ctx.opponent.stamina + 3,
      },
      drawSelf: 1,
      drawOpponent: 1,
      log: [
        "Pick Up Your Weapon — both players ready weapons, +3 stamina, draw 1",
      ],
    };
  },
};
